export function unique(value: any, index: number, values: any[]) {
    return values.indexOf(value) === index;
}